import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { EstateConsentType } from '/@/modules/estate/enums/EstateConsentType';

export class EstateConsent extends BaseEntityModel {
  /**
   * @var {number}
   */
  id;

  /**
   * @var {number}
   */
  estateId;

  /**
   * @var {string}
   */
  type;

  /**
   * @var {boolean}
   */
  value;

  /**
   * @var {string}
   */
  updatedAt;

  constructor(model = {}) {
    super(model);

    this.id = model.id;
    this.estateId = model.estateId;
    this.type = model.type;
    this.value = model.value;
    this.updatedAt = model.updatedAt;
  }

  /**
   * @returns {boolean}
   */
  get isTypeConsentForPartnerToAccessEstateAccount() {
    return this.type === EstateConsentType.CONSENT_FOR_PARTNER_TO_ACCESS_ESTATE_ACCOUNT;
  }

  get isConsentForTrueCertifiedCopyOfWill() {
    return this.type === EstateConsentType.CONSENT_FOR_TRUE_CERTIFIED_COPY_OF_WILL;
  }

  get isConsentForTrueCertifiedCopyOfProtectionMandate() {
    return this.type === EstateConsentType.CONSENT_FOR_TRUE_CERTIFIED_COPY_OF_PROTECTION_MANDATE;
  }

  get isConsentToTermsOfUse() {
    return this.type === EstateConsentType.CONSENT_TO_TERMS_OF_USE;
  }

  get isConsentToPrivacyPolicy() {
    return this.type === EstateConsentType.CONSENT_TO_PRIVACY_POLICY;
  }

  get isConsentToPlanningPurchaseTerms() {
    return this.type === EstateConsentType.CONSENT_TO_PLANNING_PURCHASE_TERMS;
  }

  get isConsentToProfessionalExecutorFeeSchedule() {
    return this.type === EstateConsentType.CONSENT_TO_THE_PROFESSIONAL_EXECUTOR_FEE_SCHEDULE;
  }
}
